import {
    Component,
    Input,
    Output,
    EventEmitter,
    forwardRef,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleSwitchComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ToggleSwitchComponent implements ControlValueAccessor {
    @Input() public label: string = '';
    @Input() public tooltipText: string = '';
    @Input() public disabled: boolean = false;
    @Input() public showTooltip: boolean = false;
    @Input() public beforeChange:
        ((newValue: boolean) => Promise<boolean> | boolean) | undefined;
    @Output() public valueChange = new EventEmitter<boolean>();

    public value: boolean = false;

    public async onToggle(): Promise<void> {
        if (this.disabled) return;

        const isToggledOn = !this.value;

        if (this.beforeChange) {
            const isAllowed = await this.beforeChange(isToggledOn);
            if (!isAllowed) return;
        }

        this.value = isToggledOn;
        this.onChange(this.value);
        this.onTouched();
        this.valueChange.emit(this.value);
    }

    // ControlValueAccessor implementation
    public writeValue(value: boolean): void {
        this.value = value || false;
    }

    public registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
    private onChange: (value: boolean) => void = () => {
        // Default implementation
    };
    private onTouched: () => void = () => {
        // Default implementation
    };
}
